import { Component, Input } from '@angular/core'
import { Accompaniment } from '../../../models/accompaniment.interface'
import { Pagination } from '../../../models/pagination.interface'
import { Observable } from 'rxjs/internal/Observable'
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms'
import { LayoutService } from '../../../services/layout/layout.service'
import { ActivatedRoute, Router } from '@angular/router'
import { UploadfileService } from '../../../services/uploadfile/uploadfile.service'
import { ToastrService } from 'ngx-toastr'
import { Title } from '@angular/platform-browser'
import { catchError, map, of, switchMap, tap } from 'rxjs'
import { PAGINATION } from '../../../shared/constants'
import { Filter, QueryGet } from '../../../shared/query-types'
import { AccompanimentService } from '../../../services/accompaniment/accompaniment.service'
import { AsyncPipe, DatePipe, NgIf } from '@angular/common'
import { MatIcon } from '@angular/material/icon'
import {
    MatCell,
    MatCellDef,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderCellDef,
    MatHeaderRow,
    MatHeaderRowDef,
    MatRow,
    MatRowDef,
    MatTable,
} from '@angular/material/table'
import { NgxPaginationModule } from 'ngx-pagination'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatNativeDateModule, MatOptionModule } from '@angular/material/core'
import { MatSelectModule } from '@angular/material/select'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { MatInput } from '@angular/material/input'
import { OnlysuperuserDirective } from '../../../directives/onlysuperuser.directive'
import { MatDialog } from '@angular/material/dialog'
import { AccompanimentFormComponent } from '../accompaniment-form/accompaniment-form.component'

@Component({
    selector: 'app-accompaniment',
    standalone: true,
    imports: [
        NgIf,
        MatIcon,
        MatTable,
        MatColumnDef,
        MatHeaderCellDef,
        MatHeaderCell,
        MatCellDef,
        MatCell,
        MatHeaderRowDef,
        MatHeaderRow,
        MatRowDef,
        MatRow,
        NgxPaginationModule,
        AsyncPipe,
        DatePipe,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatOptionModule,
        MatSelectModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatInput,
        OnlysuperuserDirective,
    ],
    templateUrl: './accompaniment.component.html',
    styleUrl: './accompaniment.component.css',
})
export class AccompanimentComponent {
    public page: number | undefined
    @Input() filtro: string = ''
    @Input() orden: string = ''
    limit = 10
    total = 0
    asyncAccompaniment!: Observable<Pagination<Accompaniment[]>>
    accompanimentList: Accompaniment[] = []
    filterForm!: FormGroup

    showColumns: string[] = [
        'acciones',
        'date',
        'description',
        'address',
        'location',
        'file',
    ]

    constructor(
        private router: Router,
        private title: Title,
        private serviceAccompaniment: AccompanimentService,
        private toastr: ToastrService,
        private fb: FormBuilder,
        private layoutService: LayoutService,
        private activatedRouter: ActivatedRoute,
        private uploadfileService: UploadfileService,
        private dialog: MatDialog
    ) {
        this.title.setTitle('Seguimientos')
    }

    ngOnInit(): void {
        this.filterForm = this.fb.group({
            date: [''],
        })

        this.fetchAccompaniment(1)
        this.filterForm.valueChanges.subscribe(() => {
            this.onFilter()
        })

        this.layoutService.paginationLimit$
            .pipe(
                switchMap((limit) => {
                    this.limit = limit
                    return this.activatedRouter.queryParamMap
                }),
                switchMap((params) => {
                    const pageNum = params.get('page') || '1'
                    const search = params.get('search') || ''
                    this.page = parseInt(pageNum)
                    this.fetchAccompaniment(PAGINATION.first_page, null, search)
                    return this.layoutService.paginationLimit$
                })
            )
            .subscribe()

        this.serviceAccompaniment.accompaniments$.subscribe(
            (accompaniment) => (this.accompanimentList = accompaniment)
        )
    }

    fetchAccompaniment(
        page: number,
        filter: Filter | null = null,
        search = ''
    ): void {
        const offset = page > 1 ? page * this.limit - this.limit : 0
        const params: QueryGet = {
            order: '-id',
            limit: this.limit,
            offset,
            search,
            filters: [{ name: 'isActive', value: 1 }],
        }

        if (filter) {
            params.filters.push(filter)
        }
        this.page = page
        this.asyncAccompaniment = this.serviceAccompaniment
            .allAccompaniments(params)
            .pipe(
                tap((response) => {
                    this.accompanimentList = response.results
                    this.serviceAccompaniment.setAccompaniments(
                        response.results
                    )
                    this.total = response.count
                }),
                map((res) => {
                    return res
                }),
                catchError((error) => {
                    console.error('Error cargando seguimientos:', error)
                    this.router.navigate(['home/'])
                    return []
                })
            )
    }

    openFile(accompaniment: Accompaniment): void {
        const id = accompaniment?.fileAttach?.fileUrl
        const name = accompaniment?.fileAttach?.fileName || 'archivo'
        this.uploadfileService.openPdfById(id, name).subscribe({
            error: () => {
                const msg = `No se pudo descargar o previsualizar el archivo`
                this.toastr.error(msg, 'Error', {
                    progressBar: true,
                    timeOut: 5000,
                })
            },
        })
    }

    hasFile(accompaniment: Accompaniment) {
        return (
            !!accompaniment?.fileAttach?.fileUrl &&
            !!accompaniment?.fileAttach?.fileName
        )
    }

    editAccompaniment(accompaniment: Accompaniment) {
        this.serviceAccompaniment.setSelectedAccompaniment(accompaniment)

        const dialogRef = this.dialog.open(AccompanimentFormComponent, {
            width: '90vw',
            maxWidth: '80vw',
            maxHeight: '80vh',
            panelClass: 'custom-dialog-container',
            data: {
                isCreate: false,
            },
        })

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this.fetchAccompaniment(PAGINATION.first_page)
            }
        })
    }

    ExportTrackings() {
        this.toastr.info('Exportar aún no implementado')
    }

    onFilter(): void {
        const { date } = this.filterForm.value
        let filter: Filter | null = null

        if (date) {
            const formattedDate = new Date(date).toISOString().split('T')[0]
            filter = { name: 'date', value: formattedDate }
        }

        this.fetchAccompaniment(PAGINATION.first_page, filter)
    }

        deleteAccompaniment(accompanimentId: number) {
            if (confirm('¿Seguro que deseas eliminar este seguimiento?')) {
                this.serviceAccompaniment
                    .deleteAccompaniment(accompanimentId)
                    .pipe(
                        tap(() => {
                            const successMsg = `Eliminado CORRECTAMENTE!`
                            this.toastr.success(successMsg, 'Exitoso!', {
                                progressBar: true,
                                timeOut: 5000,
                            })
                            this.fetchAccompaniment(PAGINATION.first_page)
                        }),
                        catchError((err) => {
                            console.error('Error eliminando seguimiento:', err)
                            const successMsg = `NO se pudo eliminar!`
                            this.toastr.error(successMsg, 'Error!', {
                                progressBar: true,
                                timeOut: 5000,
                            })
                            return of(null)
                        })
                    )
                    .subscribe()
            }
        }
}
